module.exports = __webpack_public_path__ + "static/media/ICON_chevronUP_Dark.823f7864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ICON_chevronUP_Dark.svg
// module id = 190
// module chunks = 0